import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { addMoneyToWalletFailure, addMoneyToWalletSuccess } from '../../actions/InfluencerCampaignActions/addMoneyToWalletActions';

function* addMoneyToWallet({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.addMoneyToWallet,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("ADD_MONEY_TO_WALLET_SUCCESS status :", response.data.status);
        console.log("ADD_MONEY_TO_WALLET_SUCCESS data :", response.data.response);
        console.log("ADD_MONEY_TO_WALLET_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            addMoneyToWalletSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("ADD_MONEY_TO_WALLET_FAILURE status :", error?.response?.status);
        console.log("ADD_MONEY_TO_WALLET_FAILURE data:", error?.response?.data);
        console.log("ADD_MONEY_TO_WALLET_FAILURE error :", error);
        console.log('====================================');
        yield put(addMoneyToWalletFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* addMoneyToWalletSaga() {
    yield takeLatest(actionTypes.ADD_MONEY_TO_WALLET_REQUEST, addMoneyToWallet);
}

export default addMoneyToWalletSaga;
